/**
 * aggiunge la classe css all'elemento
 */
export const addClass = (el: HTMLElement, className: string): void => {
  if (!el) {
    return;
  }

  el.classList.add(className);
};

/**
 * rimuove la classe css all'elemento
 */
export const removeClass = (el: HTMLElement, className: string): void => {
  if (!el) {
    return;
  }

  el.classList.remove(className);
};

/**
 * trova l'elemento wrapper dell'elemento, cercando il primo
 * elemento padre che abbia la classe css stabilita
 */
export const findWrapper = (
  el: HTMLElement,
  search: string
): HTMLElement | undefined => {
  let wrapper = el && el.parentElement;

  while (!!wrapper && !wrapper.classList.contains(search)) {
    if (wrapper.tagName === 'BODY') {
      wrapper = undefined;
    } else {
      wrapper = wrapper.parentElement;
    }
  }

  return wrapper;
};
